/**
 * The report templates seeded into the Reports gallery: none today. The foundry pack's three demo templates (Monthly
 * production review, Sand system health, Defect attribution) rendered against fixture data, never a tenant's, and were
 * already out of the gallery; their last reader, the import wizard's auto-report, went with Reports' retired Import data
 * (D8, #1224, #1229). They are in git history before #1229, should the report authoring path want them back.
 */
import type { ReportConfig } from "./types";

export const GALLERY_REPORT_TEMPLATES: ReportConfig[] = [];
